// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper__1yt_g","header":"index_header__1lqvB"};